/*
  * This mixin is very specific for misc program transactionList
  * It is a kind of misc-transactionList extended file
  * Be careful before mixin it anywhere else
*/
import gql from 'graphql-tag';
import { mapActions, mapState, mapGetters } from 'vuex';
import { bulkResult } from '../../../util/shared/graphql-global';
import {
  toFiscalYear,
  toIsoDate,
} from '../../../util/shared/tmc-global';
import {
  defaultOverlayConfig,
  extractId,
  incrementOverlay,
  isEmptyObject,
} from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import { getWorkstationNumber } from '../../../util/workstation-util';
import { printerHandler } from '../../../util/pdf-to-printer.util';

const { backend, backendRest } = clients.direct;

const calculateTaxFundSummary = async (miscTransId, self) => {
  const criteria = {
    ids: miscTransId,
  };
  let results;
  try {
    results = await backend.query({
      query: gql` query calculateTaxFundSummary($criteria: calculateTaxFundSummaryCriteriaType) {
        calculateTaxFundSummary(criteria: $criteria) {
            ${bulkResult}
          }
        }`,
      variables: { criteria },
      fetchPolicy: 'no-cache',
    });
  } catch (error) {
    self.flashError('Unable to calculate tax summary. Some server error.');
  }
  return results;
};

const createGroupFromArr = ({ transArr = [], keyName }) => {
  const groupData = {};

  for (let j = 0; j < (transArr || []).length; j += 1) {
    const newObj = { ...transArr[j] };
    groupData[`${newObj[keyName]}`] = newObj;
  }
  return groupData;
};

export default {
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapState({
      businessDateRange: (state) => state.misc.miscTransaction.businessDateRange,
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem,
    }),
  },
  incrementOverlay,
  methods: {
    ...mapActions(['flashInfo', 'flashError']),
    ...mapActions('misc/miscTransaction', [
      'loadBusinessDateRange',
    ]),
    /* keeping this here for Abhinav's task that involves batch payment.
       Note: I've refactored postProccessMiscData to resemble cleaner format and structure in Mtg

    isContainingMiscPaymentDetails(item) {
      return ((!Array.isArray(item.paymentDetails)
        || item.paymentDetails.length === 0)
        && (!(Array.isArray((item.transactionNumberObject || {}).paymentDetails))
        || ((item.transactionNumberObject || {}).paymentDetails || []).length === 0));
    },
    postProccessMiscData(items) {
      const cssProp = ['orange', 'accent-1'];
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        if (this.isContainingMiscPaymentDetails(item)) {
          item.crudRowCssAppend = cssProp;
        }
        updatedItems.push(item);
      }
      return updatedItems;
    },
    */
    postProccessData(items) {
      const cssProp = ['blue', 'accent-1'];
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        if (this.isContainingDetails(item) && !item.isCorrection) {
          item.crudRowCssAppend = cssProp;
        }
        updatedItems.push(item);
      }
      return updatedItems;
    },
    async getBusinessDate() {
      let businessDate = this.todaysDate; // Default to today's date
      if (this.miscSettingItem && this.miscSettingItem.usedLastBusinessDate) {
        try {
          await this.loadBusinessDateRange();
          businessDate = new Date(this.businessDateRange.max) > new Date()
            ? this.businessDateRange.max
            : this.todaysDate;
        } catch (e) {
          console.warn(e);
          businessDate = this.todaysDate;
        }
      }
      return businessDate;
    },

    deleteFieldsNotRequireToUpsert(item, isDeleteId = false) {
      const updatedItem = { ...item };
      if (isDeleteId) {
        delete updatedItem._id;
      }
      delete updatedItem.fundNo;
      delete updatedItem.sourceSubSourceNumber;
      delete updatedItem.unitCodeNumber;
      delete updatedItem.shortDesc;
      delete updatedItem.hasFiles;
      delete updatedItem.crudRowCssAppend;
      return updatedItem;
    },
    updateMiscDetails(detail, dbDataGrps) {
      const {
        fundsResultGroup, sourceResultGroup, taxDistrictResultGroup,
        miscUnitCodeResultGrp,
      } = dbDataGrps;
      const miscDetail = { ...detail };
      this.miscDetailsElements.forEach(async (element) => {
        if (element === 'fund') {
          if (!isEmptyObject(fundsResultGroup) && miscDetail.fund) {
            miscDetail.fund = fundsResultGroup[miscDetail.fund.fund]
              ? fundsResultGroup[miscDetail.fund.fund]._id : null;
          } else {
            miscDetail.fund = null;
          }
        } else if (element === 'source') {
          if (!isEmptyObject(sourceResultGroup) && miscDetail.source) {
            miscDetail.source = sourceResultGroup[miscDetail.source.sourceSubSourceNumber]
              ? sourceResultGroup[miscDetail.source.sourceSubSourceNumber]._id : null;
          } else {
            miscDetail.source = null;
          }
        } else if (element === 'taxDistrict') {
          if (!isEmptyObject(taxDistrictResultGroup) && miscDetail.taxDistrict) {
            miscDetail.taxDistrict = taxDistrictResultGroup[miscDetail.taxDistrict.districtCode]
              ? taxDistrictResultGroup[miscDetail.taxDistrict.districtCode]._id : null;
          } else {
            miscDetail.taxDistrict = null;
          }
        } else if (element === 'unit') {
          if (!isEmptyObject(miscUnitCodeResultGrp) && miscDetail.unit) {
            // #migrateUnitCode -> remove Unit after migration
            miscDetail.unit = miscUnitCodeResultGrp[miscDetail.unit.unitCode]
              ? miscUnitCodeResultGrp[miscDetail.unit.unitCode]._id : null;
            miscDetail.taxUnitCode = miscUnitCodeResultGrp[miscDetail.unit.unitCode]
              ? miscUnitCodeResultGrp[miscDetail.unit.unitCode] : null;
          } else {
            miscDetail.unit = null; // #migrateUnitCode -> remove Unit after migration
            miscDetail.taxUnitCode = null;
          }
        }
      });
      return miscDetail;
    },
    miscDuplicateTransDailogBox() {
      this.miscTransAdditionalDialogBox = true;
      this.miscTransAdditionalDialog.showCancelBtn = true;
      /* While duplicating Misc Receipts if user has selected Yes,
       it will copy amount & payment details otherwise it will copy
       misc trans with amount 0.00 and payment details will be empty */
      this.miscTransAdditionalDialog.headerText = `Are you sure want to duplicate ${(this.selectedItems || []).length} record(s)
        and also include amount(s)?`;
      this.miscTransAdditionalDialog.dialogBoxType = 'duplicateMiscTransactions';
      this.miscTransAdditionalDialog.btnOneText = 'YES (duplicates with amounts)';
      this.miscTransAdditionalDialog.btnTwoText = 'NO (duplicates without amounts)';
    },
    async miscTransAdditionalDialogAction(isResponseFlag) {
      this.miscTransAdditionalDialogBox = false;
      this.miscTransAdditionalDialog.headerText = '';
      this.miscTransAdditionalDialog.showCancelBtn = false;
      if (Object.prototype.toString.call(isResponseFlag) === '[object Boolean]') {
        if (this.miscTransAdditionalDialog.dialogBoxType === 'duplicateMiscTransactions') {
          this.miscTransAdditionalDialog.dialogBoxType = '';
          this.miscTransAdditionalDialog.isCopyAmount = isResponseFlag;
          await this.miscDuplicateTrans();
        } else {
          await this.duplicateTrans({
            isUseLatestFiscalYear: isResponseFlag,
            isCopyAmount:
            this.miscTransAdditionalDialog.isCopyAmount,
          });
        }
      }
    },
    async miscDuplicateTrans() {
      const miscRegYears = this.fiscalYearList || [];
      const currentFiscalYear = (miscRegYears[miscRegYears.length - 1] || {}).year
        || toFiscalYear(new Date(this.todaysDate));
        /* While duplicating Misc Receipts check if user has selected another Fiscal Year
         in the criteriaState, if Fiscal Year is other than current Fiscal Year then show
         dialog box */
      if (this.criteriaState.fiscalYear !== currentFiscalYear) {
        this.miscTransAdditionalDialogBox = true;
        this.miscTransAdditionalDialog.btnOneText = 'YES';
        this.miscTransAdditionalDialog.btnTwoText = 'NO';
        this.miscTransAdditionalDialog.headerText = 'Do you want to create this in most current fiscal year ?';
      } else {
        await this.duplicateTrans({
          isUseLatestFiscalYear: false,
          isCopyAmount:
           this.miscTransAdditionalDialog.isCopyAmount,
        });
      }
    },
    async duplicateTrans({ isUseLatestFiscalYear, isCopyAmount }) {
      let fiscalYear;
      const miscRegYears = this.fiscalYearList || [];
      const latestFiscalYear = (miscRegYears[miscRegYears.length - 1] || {}).year
        || toFiscalYear(new Date(this.todaysDate));
      if (isUseLatestFiscalYear) {
        fiscalYear = latestFiscalYear;
      } else {
        fiscalYear = this.selectedItems[0] ? this.selectedItems[0].fiscalYear : latestFiscalYear;
      }
      const criteria = { fiscalYear };
      const fundsResultArr = await this.loadFunds({ criteria });
      const fundsResultGroup = createGroupFromArr({ transArr: fundsResultArr, keyName: 'fund' });

      const sourceResultArr = await this.loadCmnSource({ criteria });
      const sourceResultGroup = createGroupFromArr({
        transArr: sourceResultArr,
        keyName: 'sourceSubSourceNumber',
      });

      const taxDistrictResultArr = await this.loadTaxDistrict({ criteria: {} });
      const taxDistrictResultGroup = createGroupFromArr({
        transArr: taxDistrictResultArr,
        keyName: 'districtCode',
      });

      const miscUnitCodeResultArr = await this.loadMiscUnitCode({ criteria });
      const miscUnitCodeResultGrp = createGroupFromArr({ transArr: miscUnitCodeResultArr, keyName: 'unitCode' });

      const dbDataGrps = {
        fundsResultGroup,
        sourceResultGroup,
        taxDistrictResultGroup,
        miscUnitCodeResultGrp,
      };

      this.overlay.flag = true;
      const isoData = toIsoDate(this.markingDateForItems);
      const wkst = getWorkstationNumber();
      const businessDate = await this.getBusinessDate();
      for (let i = 0; i < (this.selectedItems || []).length; i += 1) {
        const copiedItem = JSON.parse(JSON.stringify(this.selectedItems[i]));
        const upsItem = this.deleteFieldsNotRequireToUpsert(copiedItem, true);
        upsItem.fiscalYear = fiscalYear;
        await this.loadLastReceiptNo({ fiscalYear: upsItem.fiscalYear });
        await this.loadLastTransactionNo({ fiscalYear: upsItem.fiscalYear });
        upsItem.wkst = wkst;
        upsItem.taxYear = this.miscSettingItem.taxYear;
        upsItem.receiptNumber = this.nextReceiptNumber;
        upsItem.transactionNumber = this.nextTransNumber;
        upsItem.bank = extractId(upsItem.bank);
        upsItem.businessDate = businessDate;
        upsItem.amount = isCopyAmount ? upsItem.amount : 0.00;
        upsItem.details = (upsItem.details || []).map((element) => {
          const updatedElement = this.updateMiscDetails(element, dbDataGrps);
          updatedElement.amount = isCopyAmount ? updatedElement.amount : 0.00;
          return updatedElement;
        });
        if (!isCopyAmount) {
          upsItem.paymentDetails = [];
        }
        await this.upsertMiscTrans({ baseCrudKey: this.baseCrudKey, item: upsItem });
        this.miscTransAdditionalDialog.isCopyAmount = false;
        incrementOverlay(this, (this.selectedItems || []).length, i);
      }
      this.criteriaState.fromBusinessDate = isoData;
      this.criteriaState.fiscalYear = fiscalYear;
      this.$nextTick(() => {
        this.handleLoadCRUDList();
      });
      this.overlay = defaultOverlayConfig();
      this.selectedItems = [];
    },
    async upsertMiscData(closeDialog = false) {
      const result = await this.upsrtTransaction(this.activeEditedItem, closeDialog);
      if (result) {
        this.settingFields(result);
        return result._id;
      }
      return null;
    },
    async printTaxFundSummary() {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (isValidForm) {
        // pass in 'false' so that printing doesn't close the dialog box
        const miscTransId = await this.upsertMiscData(false);
        if (miscTransId) {
          this.generateAndFetchTaxFundSummaryWorkFile(miscTransId);
        }
      }
    },
    async printTaxFundSummaryFromList() {
      const miscTransId = this.selectedItems.map((t) => t._id).join(',');
      if (miscTransId) {
        this.generateAndFetchTaxFundSummaryWorkFile(miscTransId);
      }
    },
    async generateAndFetchTaxFundSummaryWorkFile(miscTransIds) {
      const { jwt } = await this.reAuth();
      const result = await calculateTaxFundSummary(miscTransIds, this);
      if (result) {
        const urlForCollectionSummary = `${backendRest.defaults.baseURL}/misc/collection-summary-from-levies-apportionment?ids=${miscTransIds}&token=${jwt}`;
        const urlForDistrictBreakdown = `${backendRest.defaults.baseURL}/misc/apportionment-school-district-breakdown?ids=${miscTransIds}&token=${jwt}`;
        this.$nextTick(() => {
          // window.open(urlForCollectionSummary, '_blank');
          printerHandler(this, { url: urlForCollectionSummary });
        });
        this.$nextTick(() => {
          // window.open(urlForDistrictBreakdown, '_blank');
          printerHandler(this, { url: urlForDistrictBreakdown });
        });
      }
    },
    async deleteBatchPaymentDetails(batchPaymentRecord) {
      const miscTransactionRecords = await this.loadMiscTransaction({
        criteria: { transactionNumberObject: batchPaymentRecord._id },
      });
      this.handleTransactionsAfterBatchPayment(miscTransactionRecords, { operation: 'delete' });
    },
    isContainingDetails(item) {
      return ((!Array.isArray(item.paymentDetails)
        || item.paymentDetails.length === 0)
        && (!(Array.isArray((item.transactionNumberObject || {}).paymentDetails))
        || ((item.transactionNumberObject || {}).paymentDetails || []).length === 0));
    },
    async handleBatchPaymentForNewOperation(item, batchPaymentRecord) {
      const itemForUpsert = {
        _id: item._id,
        transactionNumberObject: batchPaymentRecord._id,
        transactionNumber: batchPaymentRecord.transactionNumber,
      };
      return itemForUpsert;
    },
    async handleBatchPaymentForDeleteOperation(item) {
      const maxTransactionNumber = await this.loadLastTransactionNo({
        fiscalYear: item.fiscalYear,
      });
      const nextTransactionNumber = maxTransactionNumber + 1;
      const itemForUpsert = {
        _id: item._id,
        transactionNumberObject: null,
        transactionNumber: nextTransactionNumber,
      };
      return itemForUpsert;
    },
    async upsertMisTransactionAfterBatchPayment(selectedTransactions, buildUpsertItem,
      { batchPaymentRecord }) {
      for (let i = 0; i < (selectedTransactions || []).length; i += 1) {
        const selectedTransaction = { ...selectedTransactions[i] };
        const itemForUpsert = await buildUpsertItem(selectedTransaction, batchPaymentRecord);
        await this.upsertMiscTrans({
          baseCrudKey: this.baseCrudKey,
          item: itemForUpsert,
          postProcessTransaction: this.postProccessData,
        });
      }
    },
    async upsertBatchPaymentDetails(batchPaymentRecord) {
      this.handleTransactionsAfterBatchPayment(this.selectedItems, { batchPaymentRecord, operation: 'new' });
    },
    async handleTransactionsAfterBatchPayment(selectedTransactions,
      { batchPaymentRecord, operation }) {
      switch (operation) {
        case 'new':
          await this.upsertMisTransactionAfterBatchPayment(
            selectedTransactions,
            this.handleBatchPaymentForNewOperation,
            { batchPaymentRecord },
          );
          this.customCloseDialogBoxUtility();
          break;
        case 'update':
          // logic for existing batch payment details
          this.customCloseDialogBoxUtility();
          this.$nextTick(() => {
            this.handleLoadCRUDList();
          });
          break;
        case 'delete':
          await this.upsertMisTransactionAfterBatchPayment(
            selectedTransactions,
            this.handleBatchPaymentForDeleteOperation,
            {},
          );
          this.settingDialogVal(false);
          this.customCloseDialogBoxUtility();
          break;
        default:
          break;
      }
      this.selectedItems = [];
    },
    customCloseDialogBoxUtility() {
      this.setIsVisible([this.baseCrudKey, false]);
      this.$nextTick(() => {
        this.editedItem = { ...this.newItemDialog };
      });
    },
  },
};
